<template>
  <div class="document-preview-minimal">
    <div class="d-flex justify-content-between">
      <div class="d-flex gap-5">
        <span class="text-gray">{{ $t('document.f.document-code') }}:</span>
        <span class="detail-item">{{ documentData?.code }}</span>
      </div>

      <div class="d-flex gap-5">
        <span class="text-gray">{{ $t('document.f.date') }}:</span>
        <span class="detail-item">{{ convertDate(documentData?.date, false) }}</span>
      </div>

    </div>

    <div class="d-flex gap-5">
      <span class="text-gray">{{ $t('document.f.description') }}:</span>
      <span class="detail-item">{{ documentData?.description }}</span>
    </div>

    <div class="mt-4">
      <table class="table table-bordered table-sm mb-0">
        <thead>
          <tr>
            <th>رد</th>
            <th>{{ $t('document.f.account') }}</th>
            <template v-for="(_, index) in documentData?.maxCenters">
              <th>{{ $t('document.f.center') }} {{ index + 1 }}</th>
            </template>
            <th>{{ $t('document.f.description') }}</th>
            <th>{{ $t('document.f.debtor') }}</th>
            <th>{{ $t('document.f.creditor') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr :class="{ 'highlight-row': detailId === detail.id }" v-for="(detail) in documentData?.details" :key="detail.id">
            <td>{{ detail.displayOrder }}</td>
            <td>{{ detail.account?.name }} ({{ detail.account?.code }})</td>
            <template v-for="center in documentData?.maxCenters">
              <td>{{ detail.centers[center - 1] ? `${detail.centers[center - 1].name} (${detail.centers[center - 1].accountingCode})` : `` }}</td>
            </template>
            <td>{{ detail.description }}</td>
            <td>{{ monify(detail.currencyValues[0].debit) }}</td>
            <td>{{ monify(detail.currencyValues[0].credit) }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td :colspan="3 + documentData?.maxCenters" class="text-start">جمع:</td>
            <td>{{ monify(documentData?.sumDebits) }}</td>
            <td>{{ monify(documentData?.sumCredits) }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>
<script>
  import maxBy from 'lodash/maxBy'
  import cloneDeep from 'lodash/cloneDeep'
  export default {
    name: 'document-preview-minimal',
    props: {
      data: {
        type: Object,
        required: true
      },
      detailId: {
        type: String,
        required: false
      }
    },
    data() {
      return {
        documentData: null
      }
    },
    mounted() {
      this.documentData = cloneDeep(this.data)

      this.documentData.details.forEach(detail => detail.centers.sort((a, b) => a.level - b.level))
      this.documentData.maxCenters = maxBy(this.documentData.details, 'centers.length').centers.length
    }
  }
</script>
<style></style>